import axios from '../plugins/axios'

export default {
    search({ widget_id }){
        return axios.get('/api/v1/creatives/search', { params: {
          widget_id: widget_id
        }
      })
    },
    create(params) {
      return axios.post('/api/v1/creatives/create', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    create_scenario(params) {
      return axios.post('/api/v1/creatives/create_scenario', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    edit_scenario(params) {
      return axios.post('/api/v1/creatives/edit_scenario', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    update(params){
      return axios.post('/api/v1/creatives/update', params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    destroy(params){
      return axios.post('/api/v1/creatives/destroy', params)
    },
    toggle_display({ url_token }){
      return axios.post('/api/v1/creatives/toggle/display', {
        url_token: url_token
      })
    },
    toggle_all_display({ url_token }){
      return axios.post('/api/v1/creatives/toggle/all_display', {
        url_token: url_token
      })
    },
    update_order({ lists }){
      return axios.post('/api/v1/creatives/order/update', {
        lists: lists
      })
    },
    chained_popup_options({ popup_url_token }) {
      return axios.get(`/users/popups/${popup_url_token}/creatives/chained_popup_options`)
    },
}
